import React, { useState, useEffect } from "react";
import { PieChart, Pie, Cell } from "recharts";

export default function App({ color, value }) {
  const [data, setData] = useState([
    { name: "Group A", value: 10 },
    { name: "Group B", value: 90 },
  ]);

  const COLORS = [color, "transparent"];

  useEffect(() => {
    if (value && value !== "") {
      const num = parseInt(value);
      let tempArray = [...data];
      if (Number.isInteger(num)) {
        tempArray[0]["value"] = num;
        tempArray[1]["value"] = 100 - num;
      } else {
        tempArray[0]["value"] = 100;
        tempArray[1]["value"] = 90;
      }
      setData(tempArray);
    }
  }, [value]);

  return (
    <PieChart width={80} height={80}>
      <Pie
        data={data}
        cx={30} // Adjusted to center
        cy={30} // Adjusted to center
        innerRadius={20} // Adjust the inner radius for the hole
        outerRadius={30} // Adjust the outer radius to fit 80px diameter
        paddingAngle={5}
        dataKey="value"
        isAnimationActive={false}
      >
        {data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
        ))}
      </Pie>
    </PieChart>
  );
}
